import Vue from 'vue'
import Dexie from 'dexie'
import user from './user'
import network from './network'

const state = {
    databaseName: 'YelloDB_' + localStorage.fqdn,
    version: 1,
    schema: {
        // agents: '++id',
        // attributes: '++id',
        // carriers: '++id',
        // companyareas: '++id',
        // companycategories: '++id',
        // contacts: '++id',
        // ddts: '++id',
        // deadlines: '++id',
        // destinations: '++id',
        // movements: '++id',
        // opportunities: '++id',
        // pricelists: '++id',
        // productcategories: '++id',
        // projects: '++id',
        // purchaseddts: '++id',
        // quotations: '++id',
        // saleorders: '++id',
        // roles: '++id',
        // sectionals: '++id',
        // supplierdestinations: '++id',
        // suppliers: '++id',
        // tasklists: '++id',
        // timecards: '++id',
        // tasks: '++id',
        products: '++id, deleted_at',
        companies: '++id, deleted_at',
        tariffs: '++id, deleted_at',
        assets: '++id, deleted_at',
        contractors: '++id, deleted_at',
        contracts: '++id, deleted_at',
        interventions: '++id, timecardable_id, offline, deleted_at',
        interventionproduct: '++id, intervention_id, offline, deleted_at',
        troubles: '++id, offline, deleted_at',
        users: '++id, deleted_at',
        info_data: '++, &modelDef'
    }
}

const getters = {

    getData: (state) => (modelName) => {
        var db = new Dexie(getters.getDatabaseName())
        db.version(state.version).stores(state.schema)
        return db[modelName].toArray() 
    },

    getDB: (state) => {
        var db = new Dexie(getters.getDatabaseName())
        db.version(state.version).stores(state.schema)
        return db
    },
    
    getInfoData: (state) => (modelName) => {
        var db = new Dexie(getters.getDatabaseName())
        db.version(state.version).stores(state.schema)
        return db.info_data.where('modelDef').equals(modelName).first()
    },

    getDatabaseName: (state) => {
        return 'YelloDB_' + localStorage.fqdn
    },

    getDatabaseVersion: (state) => {
        return state.version
    }
}

const mutations = {
    // setSchema: (state, schema) => {
    //     schema.info_data = '++id,&modelDef'
	// 	state.schema = schema
	// },
    // setVersion: (state, version) => {
	// 	state.version = version
	// },
}

const actions = {

    uploadTroubles: ({commit, state, dispatch}) => {
        return new Promise((resolve, reject) => {

            let last_sync = 'last_sync_' + localStorage.fqdn
            var db = new Dexie(getters.getDatabaseName())
            db.version(state.version).stores(state.schema)
            db.interventionproduct.where('offline').above(0).delete()
            let troublesPromises = []

            db.troubles.where('offline').above(0).toArray().then((result) => {
                _.forEach(result, (trouble) => {
                    if (trouble.edit) {
                        troublesPromises.push(
                            Vue.axios.put('troubles/' + trouble.id, {id: trouble, signature: trouble.signature}).then(response => {
                                delete trouble.offline
                                db.troubles.put(trouble).then((count) => {

                                }).catch((error) => {
                                    // console.log(error)
                                })
                            }, response => {})
                        )
                    }
                })
    
                resolve(Vue.axios.all(troublesPromises))
            })
        })
    },


    uploadInterventions: ({commit, state, dispatch}) => {
        return new Promise((resolve, reject) => {
 
            let last_sync = 'last_sync_' + localStorage.fqdn
            var db = new Dexie(getters.getDatabaseName())
            db.version(state.version).stores(state.schema)

            let interventionsPromises = []

            db.interventions.where('offline').above(0).toArray().then((result) => {

                _.forEach(result, (intervention) => {
                    if(intervention.create) {
                        let dummyId = 0
                        _.forEach(intervention.products, (product, key) => {
                            if(product.create) {
                                intervention.products[key].id = dummyId--
                            }
                        })
                        interventionsPromises.push(
                            Vue.axios.post('interventions', intervention).then(response => {
            
                                db.interventions.where('id').equals(intervention.id).delete().then((count) => {
                                    
                                    intervention.delete().then((count) => {})

                                }).catch((error) => {
                                })
            
                            }, response => {
            
                            })
                        )
        
                    } else if (intervention.edit) {
                        let dummyId = 0
                        _.forEach(intervention.products, (product, key) => {
                            if(product.create) {
                                intervention.products[key].id = dummyId--
                            }
                        })                        
                        interventionsPromises.push(
                            Vue.axios.put('interventions/' + intervention.id, intervention).then(response => {
                                delete intervention.offline
                                db.interventions.put(intervention).then((count) => {
                                    intervention.delete().then((count) => {})

                                }).catch((error) => {
                                    // console.log(error)
                                })                                     
                            }, response => {})
                        )
                    }

                })
                resolve(Vue.axios.all(interventionsPromises))
            })
        })
    },


    uploadDB: ({commit, state, dispatch}) => {

        return dispatch('uploadInterventions').then(() => {
            dispatch('uploadTroubles').then(() => {
            })
        })
    },


    syncDB: ({commit, state}) => {

        return new Promise((resolve, reject) => {
            if(network.state.online && !!user.state.profile.offline) {
                let now = Date.now() / 1000
                now = now.toFixed(0)

                let last_sync = 'last_sync_' + localStorage.fqdn

                var db = new Dexie(getters.getDatabaseName())
                db.version(state.version).stores(state.schema)
                

                // foreach presents tables
                _.forEach(state.schema, (item, key) => {
                    // check if user have permission for download data from table
                    if(checkDownload(key)) {
                        // get info data
                        Vue.axios.get(key + '-info').then(resp_info => {
                            if(key == 'interventionproduct') {
                                db['info_data'].put({'info': resp_info.data.info, 'fields': resp_info.data.fields, 'modelDef': key}, key)
                            } else {
                                db['info_data'].put(resp_info.data.info, resp_info.data.info.modelDef)
                            }
                        }, resp_info => {
                            // error callback
                        })
                        
                        let dataObject = {
                            last_sync: localStorage[last_sync] ? localStorage[last_sync] : null,
                        }
                        
                        let url = key + '-filters'
                        
                        // get table datas
                        Vue.axios.post(url, dataObject).then(resp => {
                            db[key].bulkPut(resp.data.data.data).then(() => {
                                if(resp.data.data.data.length > 0) {
                                    let toDeleteIds = [] 
                                    _.forEach(resp.data.data.data,(row) => {
                                        if(row.deleted_at != null) {
                                            toDeleteIds.push(row.id)
                                        }
                                    })
                                    db[key].bulkDelete(toDeleteIds).then(() => {
                                    }).catch((error) => {
                                        console.log(error)
                                    })
                                }
                            })
                            // update last sync download
                            localStorage[last_sync] = now
                        }, resp => {
                            // error callback
                        })
                    }
                })


                resolve('db synced')

            } else {
                resolve('db not synced')
            }
        })
    },
}

function checkDownload(key) {
    if(key == 'info_data') {
        return false
    } else if(key == 'interventionproduct')
        return user.state.permissions.filter(permission => { return permission.api === 'interventions'}).length > 0
    else return user.state.permissions.filter(permission => { return permission.api === key}).length > 0
}

export default {
  state,
  getters,
  mutations,
  actions
}